import type { OrganizationDetail } from 'models';
import { Card, HierarchyTreeCard, SiteMapLineIcon } from 'ui';
import { useGetHierarchyTreeItems } from './hooks';

type P = {
  getPathToGroupDetail: (id: string) => string;
  organization: OrganizationDetail;
};

const OrganizationHierarchyCard = ({ getPathToGroupDetail, organization }: P) => {
  const items = useGetHierarchyTreeItems({ getPathToGroupDetail, organization });

  if (items.length === 0) {
    return null;
  }

  return (
    <HierarchyTreeCard card={{ title: <Card.Title icon={<SiteMapLineIcon />}>Hierarchy</Card.Title> }} items={items} />
  );
};

export default OrganizationHierarchyCard;
